// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__dl30Z","modal_header":"styles_modal_header__BNisk","modal_buttons":"styles_modal_buttons__DybDS"};